import { render, staticRenderFns } from "./Personalisation.vue?vue&type=template&id=7932a439"
import script from "./Personalisation.vue?vue&type=script&lang=js"
export * from "./Personalisation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports